"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BroadcastMessageApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var BroadcastMessageApi = /** @class */ (function (_super) {
    __extends(BroadcastMessageApi, _super);
    function BroadcastMessageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BroadcastMessageApi.prototype.broadcastActionMessageTemplateIdBroadcastActionPost = function (_a, opts) {
        var messageTemplateId = _a.messageTemplateId, broadcastAction = _a.broadcastAction;
        (0, runtime_1.throwIfNullOrUndefined)(messageTemplateId, 'messageTemplateId', 'broadcastActionMessageTemplateIdBroadcastActionPost');
        (0, runtime_1.throwIfNullOrUndefined)(broadcastAction, 'broadcastAction', 'broadcastActionMessageTemplateIdBroadcastActionPost');
        var headers = {};
        return this.request({
            url: '/Broadcast/action/{messageTemplateId}/{broadcastAction}'.replace('{messageTemplateId}', (0, runtime_1.encodeURI)(messageTemplateId)).replace('{broadcastAction}', (0, runtime_1.encodeURI)(broadcastAction)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastAttachmentMessageTemplateIdPost = function (_a, opts) {
        var messageTemplateId = _a.messageTemplateId, channelMessageId = _a.channelMessageId, files = _a.files;
        (0, runtime_1.throwIfNullOrUndefined)(messageTemplateId, 'messageTemplateId', 'broadcastAttachmentMessageTemplateIdPost');
        var headers = {};
        var formData = new FormData();
        if (channelMessageId !== undefined) {
            formData.append('ChannelMessageId', channelMessageId);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        return this.request({
            url: '/Broadcast/Attachment/{messageTemplateId}'.replace('{messageTemplateId}', (0, runtime_1.encodeURI)(messageTemplateId)),
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastAutomationActionAttachmentAutomationActionIdPost = function (_a, opts) {
        var automationActionId = _a.automationActionId, files = _a.files;
        (0, runtime_1.throwIfNullOrUndefined)(automationActionId, 'automationActionId', 'broadcastAutomationActionAttachmentAutomationActionIdPost');
        var headers = {};
        var formData = new FormData();
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        return this.request({
            url: '/Broadcast/AutomationAction/Attachment/{automationActionId}'.replace('{automationActionId}', (0, runtime_1.encodeURI)(automationActionId)),
            method: 'POST',
            headers: headers,
            body: formData,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastAutomationActionAttachmentFilenameIdDelete = function (_a, opts) {
        var filenameId = _a.filenameId;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'broadcastAutomationActionAttachmentFilenameIdDelete');
        var headers = {};
        return this.request({
            url: '/Broadcast/AutomationAction/Attachment/{filenameId}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastAutomationActionAttachmentPrivateFilenameIdDownloadFilenameGet = function (_a, opts) {
        var filenameId = _a.filenameId, downloadFilename = _a.downloadFilename;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'broadcastAutomationActionAttachmentPrivateFilenameIdDownloadFilenameGet');
        (0, runtime_1.throwIfNullOrUndefined)(downloadFilename, 'downloadFilename', 'broadcastAutomationActionAttachmentPrivateFilenameIdDownloadFilenameGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/AutomationAction/Attachment/Private/{filenameId}/{downloadFilename}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)).replace('{downloadFilename}', (0, runtime_1.encodeURI)(downloadFilename)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastAutomationActionAttachmentPrivateFilenameIdGet = function (_a, opts) {
        var filenameId = _a.filenameId;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'broadcastAutomationActionAttachmentPrivateFilenameIdGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/AutomationAction/Attachment/Private/{filenameId}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastBroadcastTemplateIdRecipientStatusPost = function (_a, opts) {
        var broadcastTemplateId = _a.broadcastTemplateId, travisBackendBroadcastDomainViewModelsBroadcastRecipientStatusRequestViewModel = _a.travisBackendBroadcastDomainViewModelsBroadcastRecipientStatusRequestViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTemplateId, 'broadcastTemplateId', 'broadcastBroadcastTemplateIdRecipientStatusPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Broadcast/{broadcastTemplateId}/recipient/status'.replace('{broadcastTemplateId}', (0, runtime_1.encodeURI)(broadcastTemplateId)),
            method: 'POST',
            headers: headers,
            body: travisBackendBroadcastDomainViewModelsBroadcastRecipientStatusRequestViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastBroadcastTemplateIdStatisticsRealtimeGet = function (_a, opts) {
        var broadcastTemplateId = _a.broadcastTemplateId;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTemplateId, 'broadcastTemplateId', 'broadcastBroadcastTemplateIdStatisticsRealtimeGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/{broadcastTemplateId}/Statistics/Realtime'.replace('{broadcastTemplateId}', (0, runtime_1.encodeURI)(broadcastTemplateId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastBroadcastTempleteIdGet = function (_a, opts) {
        var broadcastTempleteId = _a.broadcastTempleteId;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTempleteId, 'broadcastTempleteId', 'broadcastBroadcastTempleteIdGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/{broadcastTempleteId}'.replace('{broadcastTempleteId}', (0, runtime_1.encodeURI)(broadcastTempleteId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastBroadcastTempleteIdStatisticsGet = function (_a, opts) {
        var broadcastTempleteId = _a.broadcastTempleteId;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTempleteId, 'broadcastTempleteId', 'broadcastBroadcastTempleteIdStatisticsGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/{broadcastTempleteId}/Statistics'.replace('{broadcastTempleteId}', (0, runtime_1.encodeURI)(broadcastTempleteId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastBroadcastWithTempletePost = function (_a, opts) {
        var travisBackendBroadcastDomainViewModelsBroadcastViewModel = _a.travisBackendBroadcastDomainViewModelsBroadcastViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Broadcast/BroadcastWithTemplete',
            method: 'POST',
            headers: headers,
            body: travisBackendBroadcastDomainViewModelsBroadcastViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastChannelGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Broadcast/channel',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastDeleteDelete = function (_a, opts) {
        var travisBackendContactDomainViewModelsRemoveCampaignViewModel = _a.travisBackendContactDomainViewModelsRemoveCampaignViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Broadcast/Delete',
            method: 'DELETE',
            headers: headers,
            body: travisBackendContactDomainViewModelsRemoveCampaignViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastDuplicateBroadcastTemplateIdPost = function (_a, opts) {
        var broadcastTemplateId = _a.broadcastTemplateId;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTemplateId, 'broadcastTemplateId', 'broadcastDuplicateBroadcastTemplateIdPost');
        var headers = {};
        return this.request({
            url: '/Broadcast/duplicate/{broadcastTemplateId}'.replace('{broadcastTemplateId}', (0, runtime_1.encodeURI)(broadcastTemplateId)),
            method: 'POST',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastDuplicatePost = function (_a, opts) {
        var travisBackendBroadcastDomainViewModelsMultipleCampaignViewModel = _a.travisBackendBroadcastDomainViewModelsMultipleCampaignViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Broadcast/duplicate',
            method: 'POST',
            headers: headers,
            body: travisBackendBroadcastDomainViewModelsMultipleCampaignViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastFileDeleteFilenameIdDelete = function (_a, opts) {
        var filenameId = _a.filenameId;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'broadcastFileDeleteFilenameIdDelete');
        var headers = {};
        return this.request({
            url: '/Broadcast/File/Delete/{filenameId}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)),
            method: 'DELETE',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastFilePrivateFilenameIdDownloadFilenameGet = function (_a, opts) {
        var filenameId = _a.filenameId, downloadFilename = _a.downloadFilename;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'broadcastFilePrivateFilenameIdDownloadFilenameGet');
        (0, runtime_1.throwIfNullOrUndefined)(downloadFilename, 'downloadFilename', 'broadcastFilePrivateFilenameIdDownloadFilenameGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/File/Private/{filenameId}/{downloadFilename}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)).replace('{downloadFilename}', (0, runtime_1.encodeURI)(downloadFilename)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastFilePrivateFilenameIdGet = function (_a, opts) {
        var filenameId = _a.filenameId, downloadFilename = _a.downloadFilename;
        (0, runtime_1.throwIfNullOrUndefined)(filenameId, 'filenameId', 'broadcastFilePrivateFilenameIdGet');
        var headers = {};
        var query = {};
        if (downloadFilename != null) {
            query['downloadFilename'] = downloadFilename;
        }
        return this.request({
            url: '/Broadcast/File/Private/{filenameId}'.replace('{filenameId}', (0, runtime_1.encodeURI)(filenameId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastGet = function (_a, opts) {
        var offset = _a.offset, limit = _a.limit, name = _a.name;
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        if (name != null) {
            query['name'] = name;
        }
        return this.request({
            url: '/Broadcast',
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastHistoryBroadcastTemplateIdExportBackgroundGet = function (_a, opts) {
        var broadcastTemplateId = _a.broadcastTemplateId;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTemplateId, 'broadcastTemplateId', 'broadcastHistoryBroadcastTemplateIdExportBackgroundGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/History/{broadcastTemplateId}/export/background'.replace('{broadcastTemplateId}', (0, runtime_1.encodeURI)(broadcastTemplateId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastHistoryBroadcastTempleteIdExportGet = function (_a, opts) {
        var broadcastTempleteId = _a.broadcastTempleteId;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTempleteId, 'broadcastTempleteId', 'broadcastHistoryBroadcastTempleteIdExportGet');
        var headers = {};
        return this.request({
            url: '/Broadcast/History/{broadcastTempleteId}/export'.replace('{broadcastTempleteId}', (0, runtime_1.encodeURI)(broadcastTempleteId)),
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastHistoryBroadcastTempleteIdGet = function (_a, opts) {
        var broadcastTempleteId = _a.broadcastTempleteId, offset = _a.offset, limit = _a.limit;
        (0, runtime_1.throwIfNullOrUndefined)(broadcastTempleteId, 'broadcastTempleteId', 'broadcastHistoryBroadcastTempleteIdGet');
        var headers = {};
        var query = {};
        if (offset != null) {
            query['offset'] = offset;
        }
        if (limit != null) {
            query['limit'] = limit;
        }
        return this.request({
            url: '/Broadcast/History/{broadcastTempleteId}'.replace('{broadcastTempleteId}', (0, runtime_1.encodeURI)(broadcastTempleteId)),
            method: 'GET',
            headers: headers,
            query: query,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastHistoryExportBackgroundPost = function (_a, opts) {
        var travisBackendBroadcastDomainViewModelsMultipleCampaignViewModel = _a.travisBackendBroadcastDomainViewModelsMultipleCampaignViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Broadcast/History/export/background',
            method: 'POST',
            headers: headers,
            body: travisBackendBroadcastDomainViewModelsMultipleCampaignViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastMessageTemplateIdPost = function (_a, opts) {
        var messageTemplateId = _a.messageTemplateId, travisBackendBroadcastDomainViewModelsNewTemplateViewModel = _a.travisBackendBroadcastDomainViewModelsNewTemplateViewModel;
        (0, runtime_1.throwIfNullOrUndefined)(messageTemplateId, 'messageTemplateId', 'broadcastMessageTemplateIdPost');
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Broadcast/{messageTemplateId}'.replace('{messageTemplateId}', (0, runtime_1.encodeURI)(messageTemplateId)),
            method: 'POST',
            headers: headers,
            body: travisBackendBroadcastDomainViewModelsNewTemplateViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastPost = function (_a, opts) {
        var travisBackendBroadcastDomainViewModelsNewTemplateViewModel = _a.travisBackendBroadcastDomainViewModelsNewTemplateViewModel;
        var headers = {
            'Content-Type': 'application/json-patch+json',
        };
        return this.request({
            url: '/Broadcast',
            method: 'POST',
            headers: headers,
            body: travisBackendBroadcastDomainViewModelsNewTemplateViewModel,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    BroadcastMessageApi.prototype.broadcastTotalGet = function (opts) {
        var headers = {};
        return this.request({
            url: '/Broadcast/Total',
            method: 'GET',
            headers: headers,
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ;
    return BroadcastMessageApi;
}(runtime_1.BaseAPI));
exports.BroadcastMessageApi = BroadcastMessageApi;
